export class SynapiPredicate {
    ids: string[];
    scids: string[];
    orids: string[];
    id:string;
    textsearch:string;
    datemax: string;
    datemin: string;
    lang: string;
    size: number;
    page: number;
    latmin: number;
    latmax: number;
    lonmin: number;
    lonmax: number;
    slug: string;
    elements: string[];
    sort?: "ids"|"default"
}
